import script from "./ViewDatasourceUserGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDatasourceUserGroups.vue?vue&type=script&setup=true&lang=js"

import "./ViewDatasourceUserGroups.vue?vue&type=style&index=0&id=d6648a9a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6648a9a"]])

export default __exports__